import {ApplicationState} from "../reducers";
import {ThunkAction} from "redux-thunk";
import {apiError, apiPost, apiRequest, CommonAction} from "./common";
import {User} from "../models/user";
import {deleteToken, setToken} from "./token";

export const LOGGING_IN = "LOGGING_IN";
export const LOGIN_COMPLETE = "LOGIN_COMPLETE";
export const LOAD_LOGGED_IN_FAILED = "LOAD_LOGGED_IN_FAILED";
export const SECURITY_API_ERROR = "SECURITY_API_ERROR";

type SecurityActionResponse = ThunkAction<Promise<SecurityAction>, ApplicationState, {}>;

export interface SecurityAction extends CommonAction {
    user?: User;
}

export function login(username: string, password: string): SecurityActionResponse {
    return dispatch => {
        dispatch({type: LOGGING_IN});
        return apiPost<User>(`/auth/signIn`, {username, password})
            .then(response => {
                setToken(response.token);
                return dispatch({
                    type: LOGIN_COMPLETE,
                    user: response
                }) as SecurityAction;
            })
            .catch(err => dispatch(apiError(SECURITY_API_ERROR, "Login Failed")));
    };
}

export function loadLoggedInUser(): SecurityActionResponse {
    return dispatch => {
        dispatch({type: LOGGING_IN});
        return apiRequest<User>("/users/me")
            .then(response => {
                return dispatch({
                    type: LOGIN_COMPLETE,
                    user: response
                }) as SecurityAction;
            })
            .catch(err => {
                dispatch({
                    type: LOAD_LOGGED_IN_FAILED
                });
                dispatch(apiError(SECURITY_API_ERROR, err));
            });
    };
}

export function logout(): SecurityActionResponse {
    return dispatch => {
        dispatch({type: LOGGING_IN});
        return apiRequest<number>("/auth/signOut")
            .then(response => {
                deleteToken();
                return dispatch({
                    type: LOGIN_COMPLETE,
                    user: null
                }) as SecurityAction;
            })
            .catch(err => dispatch(apiError(SECURITY_API_ERROR, err)));
    };
}



// WEBPACK FOOTER //
// ./src/actions/security.ts